"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMinutesBetweenTimes = void 0;
const getMinutesBetweenTimes = (start_time, end_time) => {
    const start = new Date(`01/01/2020 ${start_time}`);
    const end = new Date(`01/01/2020 ${end_time}`);
    const diff = end.getTime() - start.getTime();
    return diff / 1000 / 60;
};
exports.getMinutesBetweenTimes = getMinutesBetweenTimes;
